import { Box, Image, Text } from "@chakra-ui/react"
import { useNavigate } from "react-router-dom"



export const FontFree_card = (ele) => {
    const navigate = useNavigate()

    return (
        <Box onClick={() => navigate(`Project/${ele.url}`)} overflow={'hidden'} cursor={'pointer'} borderRadius={'25px'} boxShadow={'rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px'}>
            <Box h={'280px'} _hover={{ transform: 'scale(1.05)' }} transition={'0.4s ease'}>
                <Image borderRadius={'25px 25px 0 0 '} w={'100%'} h={'100%'} src={ele.image} alt={ele.url} />
            </Box>
            <Box w={'90%'} m={'15px auto 20px auto'}>
                <Text fontSize={'18px'} fontWeight={'bold'} textAlign={'center'}>{ele.title}</Text>
                <Text color={'grey'} m={'10px auto'}>{ele.description}</Text>
                <Box display={'flex'} gap={'7px'}>
                    {ele.language && ele.language?.map((ele, index) => (
                        <Text color={ele == 'HTML' && 'orange' || ele == 'CSS' && 'blue.400' || ele == 'JS' && '#00C853'} fontSize={'15px'} fontWeight={'medium'} key={index}>{ele}</Text>
                    ))}
                </Box>
            </Box>
        </Box>
    )

}